<div *ngIf="formData" [formGroup]="formData">
  <p-selectButton
    class="mu-select-button {{ circleSkin && 'mu-circle-skin' }} {{ customClass }}"
    [multiple]="multiple"
    optionLabel="label"
    [options]="options"
    [id]="controlName"
    [formControlName]="controlName"
  ></p-selectButton>
</div>
<div *ngIf="!formData">
  <p-selectButton
    class="mu-select-button {{ circleSkin && 'mu-circle-skin' }}"
    [multiple]="multiple"
    optionLabel="label"
    [options]="options"
    [(ngModel)]="filterList.model[filterName]"
  ></p-selectButton>
</div>
